import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { IMarkoutApiDependencySegment } from '@cbridge-packages/api-markout';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkoutAction } from '../markout.action';

type IDependencies = IMarkoutApiDependencySegment;

export const stopReportEpic: IEpic<{}, IDependencies> = (action$, _, { moApi }) =>
  action$.pipe(
    isTypeOfAndGetParamsAndResolver(MarkoutAction.stopReport.started),
    switchMap(({ params, resolve, reject }) => (
      moApi.stopReport(params.reportId).pipe(
        mergeMap(() => {
          resolve?.();
          return [
            MarkoutAction.stopReport.done({ params, result: undefined }),
            MarkoutAction.loadReports.started({}),
          ];
        }),
        catchApiError((error) => {
          const isHandled = reject?.(error.errorCode, error.description, error.params);
          return [
            MarkoutAction.stopReport.failed({ params, error }),
            ...(isHandled ? [] : [createApiErrorNotification(error)]),
          ];
        }),
      )
    )),
  );
